var _TinyObservableClass_subscriptions;
import { __classPrivateFieldGet } from "tslib";
import { MutableMap } from '../others';
export const createTinyObservable = () => new TinyObservableClass();
class TinyObservableClass {
    constructor() {
        _TinyObservableClass_subscriptions.set(this, new MutableMap());
    }
    next(value) {
        for (const fn of __classPrivateFieldGet(this, _TinyObservableClass_subscriptions, "f").values()) {
            fn(value);
        }
    }
    subscribe(fn) {
        const id = Symbol();
        __classPrivateFieldGet(this, _TinyObservableClass_subscriptions, "f").set(id, fn);
        return {
            unsubscribe: () => {
                __classPrivateFieldGet(this, _TinyObservableClass_subscriptions, "f").delete(id);
            },
        };
    }
}
_TinyObservableClass_subscriptions = new WeakMap();
